import angular from 'angular';
import { FormComponent } from './form.component';
import AsyncEmailInputModule from '../../common/directives/async-email-input';
import PasswordModule from '../../common/directives/password';

export const FormModule = angular
  .module('app.welcome.form', [AsyncEmailInputModule.name, PasswordModule.name])
  .component('updWelcomeForm', FormComponent);
